import { Component, OnInit, Inject } from '@angular/core';
import { SupportEmail, ItemSupportEmail } from 'src/app/shared/model/support-email.model';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EmailSupportService } from 'src/app/shared/service/email-support.service';

@Component({
  selector: 'app-dialog-support-detail',
  templateUrl: './dialog-support-detail.component.html',
  styleUrls: ['./dialog-support-detail.component.scss']
})
export class DialogSupportDetailComponent implements OnInit {
  supportEmail: SupportEmail = new SupportEmail();
  supportEmailForm: FormGroup;
  isModeEdit: boolean;
  constructor(
    private fb: FormBuilder,
    private service: EmailSupportService,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<DialogSupportDetailComponent>) {
    if (data && data.type === 'edit') {
      this.isModeEdit = true;
      this.supportEmail = new SupportEmail(data.body);
      this.initForm();
    } else {
      this.isModeEdit = false;
      this.supportEmail = new SupportEmail();
      this.initForm();
    }
  }

  onConfirmClick(): void {
    this.dialogRef.close(`${this.supportEmailForm.value.emails}`);
  }

  ngOnInit() { }

  initForm() {
    return this.supportEmailForm = this.fb.group({
      id: [this.supportEmail.id],
      name: [this.supportEmail.name],
      emails: this.fb.array(this.supportEmail.emails.length ?
        this.supportEmail.emails
          .map((item: ItemSupportEmail, index) => this.initItemSupportEmailForm(item))
        : [this.initItemSupportEmailForm(new ItemSupportEmail())]),
    });
  }

  initItemSupportEmailForm(item: ItemSupportEmail) {
    return this.fb.group({
      id: [item.id],
      name: [item.name, [Validators.required]],
      email: [item.email, [Validators.required]],
    });
  }

  /**
   * Marks all controls in a form group as touched
   * @param formGroup - The form group to touch
   */
  private markFormGroupTouched(formGroup: FormGroup): void {
    (Object as any).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  submitForm(): void {
    if (!this.supportEmailForm.valid) {
      this.markFormGroupTouched(this.supportEmailForm);
      return;
    } else {
      const body = this.supportEmailForm.value.emails.map((item) => new ItemSupportEmail(item, false).convertToReqBody());
      this.service.postEmailSupport(this.data.body.id, body).subscribe((res) => {
        this.onConfirmClick();
      });
    }
  }

  addItemSupportEmail() {
    const control = this.supportEmailForm.controls.emails as FormArray;
    control.push(this.initItemSupportEmailForm(new ItemSupportEmail()));
  }

  removeEmail(index) {
    const control = this.supportEmailForm.controls.emails as FormArray;
    control.removeAt(index);
  }
}
